/* eslint-disable react/prop-types */
import classes from "./composed-view-infinite-carousel.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import classNames from "classnames";
import InfiniteImageCarousel from "@/components-library/widgets/infinite-image-carousel/infinite-image-carousel";

function ComposedViewInfiniteCarousel({ title, subTitle, items, itemType }) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="center"
      className={classNames(classes.container)}
    >
      <Label
        weight="bold"
        tag="h2"
        color="secondary"
        align="start"
        className={classes.title}
      >
        {title}
      </Label>
      {subTitle && (
        <Label align="center" size="md" color="secondary">
          {subTitle}
        </Label>
      )}

      <InfiniteImageCarousel items={items} itemComponent={itemType} />
    </Flex>
  );
}

export default ComposedViewInfiniteCarousel;
